import { Button } from "./ui/button";
import { scrollToElement } from "../utils/navigation";
import VideoTooltip from "./VideoTooltip";

type HeroProps = { scrollTarget?: string };

export const Hero = ({ scrollTarget } :HeroProps ) => {
  const handleGetStarted = () => {
    scrollToElement(scrollTarget ?? 'pricing', 'Hero Begin Journey Button');
  };

  return (
    <section className="container grid lg:grid-cols-2 place-items-center py-20 md:py-32 gap-10">

      {/* Hero cards sections */}
      <div className="w-full rounded-lg p-4 text-center">
        <img src="/Mockup_Test_1_wide_Res.png" />
        <span className="inline bg-gradient-to-r from-[#D4AF37] to-[#B8860B] text-transparent bg-clip-text ">
          Lightning fast. Your entire portfolio. One platform.
          </span>
      </div>

      <div className="text-center lg:text-start space-y-4">        
        <main className="text-6xl font-bold">
          <h1 className="inline">
            <span className="inline bg-gradient-to-r from-[#D4AF37] to-[#B8860B] text-transparent bg-clip-text">
            Doyen
            </span>{" "}
            Trading
          </h1>{" "}
        </main>
        <main className="text-3xl font-bold">
          <h3 className="inline">
            <span className="inline bg-gradient-to-r from-[#FF6B35] via-[#F7931E] to-[#FFD700] text-transparent bg-clip-text">
              Professional{" "}Trading
            </span>{" "} Software
          </h3>
        </main>

        <p className="text-xl text-muted-foreground  lg:mx-0">
          <VideoTooltip videoSrc="/Algorithms-Start.webm" type="iframe" width={600} height={300}><span className="text-primary">Algorithms</span></VideoTooltip>.{" "}
          <VideoTooltip videoSrc="/Multichart.webm" type="iframe" width={600} height={300}><span className="text-white">Indicators</span></VideoTooltip>.{" "}
          <VideoTooltip videoSrc="/Newsfeed-Filtering.webm" type="iframe" width={600} height={300}><span className="text-primary">News</span></VideoTooltip>.{" "}
          <VideoTooltip videoSrc="/Dob-Custom-Size.webm" type="iframe" width={600} height={300}><span className="text-white">Multiple Exchanges</span></VideoTooltip>.{" "}
          One platform.<br/>
          Don't let the market move faster than you.
        </p>

        <div className="space-y-4 md:space-y-0 md:space-x-4">
          <Button className="w-full md:w-1/3" onClick={handleGetStarted}>
            Begin Your Journey
          </Button>

          <Button
            variant="outline"
            className="w-full md:w-1/3"
            onClick={() => window.location.href='/features'}
          >
            Explore Features
          </Button>
        </div>
      </div>

      {/* Shadow effect */}
      <div className="shadow"></div>
    </section>
  );
};
